import React from 'react'
import { Box, Button, Modal, Stack, Typography, useTheme } from '@mui/material'
import { type OverridableStringUnion } from '@mui/types'
import { type ButtonPropsColorOverrides } from '@mui/material/Button/Button'

interface ConfirmationModalProps {
  open: boolean
  onClose: () => void
  onHandle: (arg?: any) => any
  title: string
  description: string
  handleButtonLabel: string
  handleButtonColour: OverridableStringUnion<'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning', ButtonPropsColorOverrides>
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = (
  { open, onClose, onHandle, title, description, handleButtonLabel, handleButtonColour }
) => {
  const theme = useTheme()

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: 'absolute' as 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          border: `1px solid ${theme.palette.primary.main}`,
          boxShadow: 24,
          p: 4,
          color: 'white'
        }}
      >
        <Typography id="modal-modal-title" variant="h6" component="h2">
          {title}
        </Typography>
        <Typography id="modal-modal-description" sx={{ mt: 2, mb: 2, whiteSpace: 'pre-wrap' }}>
          {description}
        </Typography>
        <Stack direction='row' justifyContent='space-between'>
          <Button
            variant='outlined'
            onClick={() => { onClose() }}
          >
            Cancel
          </Button>
          <Button
            variant='contained'
            color={handleButtonColour}
            onClick={() => {
              onHandle()
              onClose()
            }}
          >
            {handleButtonLabel}
          </Button>
        </Stack>
      </Box>
    </Modal>
  )
}

export default ConfirmationModal
